<template>
    <v-form ref="form" v-model="valid" @submit.prevent="send">
        <v-layout wrap>
            <v-flex xs12>
                <v-switch v-model="input.sendUnlockBeforeConnect"
                    label="Envio de comando de desbloqueio com carro desconectado" hide-details class="my-0 py-0" />
                <v-switch v-model="input.configuration.stopWithStatusNotification"
                    label="Encerrar sessão com notificação de status disponível no OCPP" hide-details
                    class="my-0 py-0" />
            </v-flex>
            <v-flex xs12>
                <v-alert border="left" colored-border color="info" elevation="5">
                    <v-layout wrap>
                        <v-flex xs6>
                            <v-text-field v-model="input.powerMax" :rules="[rules.required, rules.range(1, 300)]"
                                label="Potência máxima" suffix="kW" type="number" dense required />
                        </v-flex>
                        <v-flex xs6>
                            <v-switch v-model="input.powerControl" label="Liberação de potência ao conectar" dense
                                hide-details class="my-0 py-0" />
                        </v-flex>
                        <v-flex xs6>
                        </v-flex>
                        <v-flex xs12 md3 v-if="input.powerControl">
                            <v-text-field v-model="input.powerFree" :rules="[rules.required, rules.range(1, 10)]"
                                label="Potência Grátis" suffix="kW" type="number" dense required />
                        </v-flex>
                        <v-flex xs12 md3 v-if="input.powerControl">
                            <v-text-field v-model="input.powerFreeTime" :rules="[rules.range(1, 60)]"
                                label="Tempo Grátis" suffix="minutos" type="number" dense required />
                        </v-flex>
                    </v-layout>
                </v-alert>
            </v-flex>
            <v-flex xs12>
                <v-alert border="left" colored-border color="info" elevation="5">
                    <h5 class="info--text">Política de preço</h5>
                    <v-layout wrap v-if="input.payment">
                        <v-flex xs12>
                            <v-select v-model="input.payment.pricePolicy" :items="policies" label="Política" dense
                                hide-details class="my-0 py-0" clearable />
                        </v-flex>
                        <v-flex xs12 v-if="input.payment.pricePolicy">
                            <v-text-field v-model="input.payment.recipient" label="Beneficiario" dense hide-details
                                required />
                        </v-flex>

                        <v-flex xs12 sm6 v-if="input.payment.pricePolicy">
                            <v-text-field v-model="input.payment.price" :rules="[rules.required, rules.money]"
                                label="Valor na Ativação" v-mask="['#.##', '##.##', '###.##']" return-masked-value
                                prefix="R$" type="number" dense required />
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field v-model="input.payment.payPartnerTransfer" :rules="[rules.range(1, 100)]"
                                label="Porcentagem parceiro" v-mask="['#', '##', '###']" return-masked-value suffix="%"
                                type="number" dense required />
                        </v-flex>

                        <v-flex xs12 v-if="input.payment.pricePolicy == 'PAYMENT_PER_CONSUMPTION'">
                            <v-alert border="left" colored-border color="info" elevation="5">
                                <h5 class="info--text">Calculo de preço</h5>
                                <v-layout wrap>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="input.payment.priceKwh"
                                            :rules="[rules.required, rules.money]" label="Preço por kWh"
                                            v-mask="['#.##', '##.##', '###.##']" return-masked-value prefix="R$"
                                            type="number" dense required />
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="input.payment.payTriggerStop" :rules="[rules.range(1, 100)]"
                                            label="Porcentagem para parar o carregamento" v-mask="['#', '##', '###']"
                                            return-masked-value suffix="%" type="number" dense required />
                                    </v-flex>

                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="input.payment.priceIdle"
                                            :rules="[rules.money]" label="Tarifa de ociosidade"
                                            v-mask="['#.##', '##.##', '###.##']" return-masked-value prefix="R$" suffix="por minuto"
                                            type="number" dense required />
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="input.payment.idleTolerance" :rules="[rules.range(1, 120)]"
                                            label="Tolerância para tarifa de ociosidade" v-mask="['#', '##', '###']"
                                            return-masked-value suffix="minutos" type="number" dense required v-if="input.payment.priceIdle" />
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="input.payment.priceConnection"
                                            :rules="[rules.money]" label="Taxa de desbloqueio"
                                            v-mask="['#.##', '##.##', '###.##']" return-masked-value prefix="R$"
                                            type="number" dense required />
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="input.payment.connectionTolerance" :rules="[rules.range(1, 120)]"
                                            label="Tolerância para taxa de desbloqueio" v-mask="['#', '##', '###']"
                                            return-masked-value suffix="minutos" type="number" dense required v-if="input.payment.priceConnection" />
                                    </v-flex>
                                    <v-flex xs12 v-if="input.payment.priceIdle && input.configuration && !input.configuration.stopWithStatusNotification">
                                        <v-alert type="warning" dense elevation="5" class="ma-0">
                                            Flag "Encerrar sessão com notificação de status disponível no OCPP" está desabilitado. 
                                            <br><br>
                                            Para ociosidade funcionar o 'StopTransaction' deve ser enviado somente no final da sessão, ou a cobrança de ociosidade não vai funcionar.
                                        </v-alert>
                                    </v-flex>
                                </v-layout>
                            </v-alert>
                        </v-flex>

                    </v-layout>
                </v-alert>
            </v-flex>
            <v-flex xs12>
                <v-alert border="left" colored-border color="success" elevation="5">
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-row class="px-4">
                                <h4 class="success--text mr-4">Stripe</h4>
                                <v-spacer />
                                <v-switch v-model="input.stripe.enable"
                                    :label="input.stripe.enable ? 'Habilitado' : 'Desabilitado'" hide-details
                                    class="mt-1 py-0" />
                                <v-btn icon @click="copyPaymentConfig('stripe', 'Stripe')" color="success">
                                    <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                                <v-btn icon @click="pastePaymentConfig('stripe', 'Stripe')" color="error">
                                    <v-icon>mdi-content-paste</v-icon>
                                </v-btn>
                            </v-row>
                        </v-flex>
                        <v-flex xs12 md6 v-show="input.stripe.enable">
                            <v-text-field v-model="input.stripe.private" label="Chave privada" dense hide-details />
                        </v-flex>
                        <v-flex xs12 md6 v-show="input.stripe.enable">
                            <v-text-field v-model="input.stripe.public" label="Chave pública" dense hide-details />
                        </v-flex>
                        <v-flex xs12 v-show="input.stripe.enable">
                            <v-text-field v-model="input.stripe.webhookKey" label="Webhook Key" dense hide-details />
                        </v-flex>

                        <v-flex xs12 v-show="input.stripe.enable">
                            <v-alert border="left" colored-border
                                :color="input.payment.payPartnerTransfer ? 'success' : 'error'" elevation="5"
                                class="ma-0">
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <h5 :class="input.payment.payPartnerTransfer ? 'success--text' : 'error--text'">
                                            Configuração de parceiro
                                            {{ input.payment.payPartnerTransfer ? '' : ' - Desabilitada (Necessário configurar porcentagem para parceiro) ' }}
                                        </h5>
                                    </v-flex>
                                    <v-flex xs12 md6 v-if="input.payment.payPartnerTransfer > 0">
                                        <v-text-field v-model="input.stripe.partner" label="Chave do parceiro (Connect)"
                                            dense hide-details />
                                    </v-flex>
                                    <v-flex xs12 md6 v-if="input.stripe.partner">
                                        <v-switch v-model="input.stripe.directChargeMode"
                                            label="Modo de cobrança direta pelo parceiro" hide-details
                                            class="my-0 py-0" />
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-alert v-if="input.stripe.directChargeMode && input.stripe.partner"
                                            border="left" colored-border
                                            :color="input.payment.payPartnerTransfer ? 'success' : 'error'"
                                            elevation="5" class="ma-0">
                                            <v-layout wrap>
                                                <v-flex xs12>
                                                    <h5
                                                        :class="input.payment.payPartnerTransfer ? 'success--text' : 'error--text'">
                                                        Valores para calculo de custo de taxa do aplicativo
                                                    </h5>
                                                </v-flex>
                                                <v-flex xs12 sm6 md4>
                                                    <v-text-field v-model="input.stripe.fee"
                                                        :rules="[rules.range(0.00, 100.000)]"
                                                        label="Taxa da stripe (Porcentagem)" v-mask="['#.##', '##.##']"
                                                        return-masked-value prefix="%" type="number" dense required />
                                                </v-flex>
                                                <v-flex xs12 sm6 md4>
                                                    <v-text-field v-model="input.stripe.feePerTransaction"
                                                        :rules="[rules.required, rules.money]"
                                                        label="Valor fixo por transação"
                                                        v-mask="['#.##', '##.##', '###.##']" return-masked-value
                                                        prefix="R$" type="number" dense required />
                                                </v-flex>
                                                <!-- <v-flex xs12 md4>
                                                    <v-text-field v-model="input.stripe.minimalFee" :rules="[rules.required, rules.money]"
                                                        label="Valor mínimo para o aplicativo cobrar a taxa" v-mask="['#.##', '##.##', '###.##']" return-masked-value prefix="R$"
                                                        type="number" dense required />
                                                </v-flex> -->
                                            </v-layout>
                                        </v-alert>
                                    </v-flex>
                                </v-layout>
                            </v-alert>
                        </v-flex>

                    </v-layout>
                </v-alert>
            </v-flex>
            <v-flex xs12>
                <v-alert border="left" colored-border color="success" elevation="5">
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-row class="px-4">
                                <h4 class="success--text mr-4">Mercado Pago (PIX)</h4>
                                <v-spacer />
                                <v-switch v-model="input.mercadopagopix.enable"
                                    :label="input.mercadopagopix.enable ? 'Habilitado' : 'Desabilitado'" hide-details
                                    class="mt-1 py-0" />
                                <v-btn icon @click="copyPaymentConfig('mercadopagopix', 'Mercado Pago (PIX)')"
                                    color="success">
                                    <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                                <v-btn icon @click="pastePaymentConfig('mercadopagopix', 'Mercado Pago (PIX)')"
                                    color="error">
                                    <v-icon>mdi-content-paste</v-icon>
                                </v-btn>
                            </v-row>
                        </v-flex>
                        <v-flex xs12 md6 v-show="input.mercadopagopix.enable">
                            <v-text-field v-model="input.mercadopagopix.private" label="Access Token" dense
                                hide-details />
                        </v-flex>
                        <v-flex xs12 md6 v-show="input.mercadopagopix.enable">
                            <v-text-field v-model="input.mercadopagopix.webhookKey" label="Webhook Key" dense
                                hide-details />
                        </v-flex>
                        <v-flex xs12 v-show="input.mercadopagopix.enable">
                            <v-alert border="left" colored-border
                                :color="(input.payment.payPartnerTransfer || input.mercadopagopix.payPartnerTransfer) ? 'success' : 'error'"
                                elevation="5" class="ma-0">
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <h5
                                            :class="(input.payment.payPartnerTransfer || input.mercadopagopix.payPartnerTransfer) ? 'success--text' : 'error--text'">
                                            Configuração de parceiro
                                            {{ (input.payment.payPartnerTransfer ||
                                                input.mercadopagopix.payPartnerTransfer)
                                                ? '' : ' - Desabilitada (Necessário configurar porcentagem para parceiro) '
                                            }}
                                        </h5>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="input.mercadopagopix.payPartnerTransfer"
                                            :rules="[rules.range(1, 100)]" label="Porcentagem parceiro"
                                            v-mask="['#', '##', '###']" return-masked-value prefix="%" type="number"
                                            dense required />
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="input.mercadopagopix.fee"
                                            :rules="[rules.range(0.00, 100.000)]"
                                            label="Taxa da Mercado Pago (Porcentagem)" v-mask="['#.##', '##.##']"
                                            return-masked-value prefix="%" type="number" dense required />
                                    </v-flex>
                                    <v-flex xs12 sm6 class="mt-4">
                                        <v-text-field v-model="input.mercadopagopix.client_id" label="Client ID" dense
                                            hide-details />
                                    </v-flex>
                                    <v-flex xs12 sm6 class="mt-sm-4">
                                        <v-text-field v-model="input.mercadopagopix.client_secret" label="Client Secret"
                                            dense hide-details />
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field v-model="input.mercadopagopix.access_token" label="Split Code"
                                            dense hide-details>
                                            <template v-slot:append>
                                                <v-btn icon small @click="refreshSplitCode" color="success"
                                                    :disabled="!input.mercadopagopix.access_token">
                                                    <v-icon small>mdi-refresh</v-icon>
                                                </v-btn>
                                                <v-btn icon small @click="deleteSplitCode" color="error"
                                                    :disabled="!input.mercadopagopix.access_token">
                                                    <v-icon small>mdi-delete</v-icon>
                                                </v-btn>
                                                <v-btn icon small @click="generateSplitCodeLink" color="primary"
                                                    class="pl-1"
                                                    :disabled="!!(input.mercadopagopix.access_token || !input.mercadopagopix.client_id || !input.mercadopagopix.client_secret)">
                                                    <v-icon small>mdi-link</v-icon>
                                                </v-btn>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md6 v-if="hasAccessToken">
                                        <v-text-field v-model="input.mercadopagopix.refresh_token"
                                            :rules="[requiredIfSplitRefreshToken]" label="Refresh Token" dense />
                                    </v-flex>
                                    <v-flex xs12 md6 v-if="hasAccessToken">
                                        <v-text-field v-model="input.mercadopagopix.expires_in"
                                            :rules="[requiredIfSplitExpiresIn]" label="Expires In" dense />
                                        <div v-if="isTokenExpired" class="caption error--text mt-1"
                                            style="font-size: 11px;">
                                            ⚠ Token expirado em {{ formattedExpiryDate }}
                                        </div>
                                        <div v-else class="caption grey--text mt-1" style="font-size: 11px;">
                                            {{ formattedExpiryDate }}
                                        </div>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-alert type="info" dense elevation="5" class="ma-0">
                                            No momento do estorno o mercado pago faz as devidas devoluções nas
                                            proporções corretas.
                                        </v-alert>
                                    </v-flex>
                                </v-layout>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-alert>
            </v-flex>
            <v-flex xs12>
                <v-alert border="left" colored-border color="success" elevation="5">
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-row class="px-4">
                                <h4 class="success--text mr-4">Pagar.me (PIX)</h4>
                                <v-spacer />
                                <v-switch v-model="input.pagarmepix.enable"
                                    :label="input.pagarmepix.enable ? 'Habilitado' : 'Desabilitado'" hide-details
                                    class="mt-1 py-0" />
                                <v-btn icon @click="copyPaymentConfig('pagarmepix', 'Pagar.me (PIX)')"
                                    color="success">
                                    <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                                <v-btn icon @click="pastePaymentConfig('pagarmepix', 'Pagar.me (PIX)')"
                                    color="error">
                                    <v-icon>mdi-content-paste</v-icon>
                                </v-btn>
                            </v-row>
                        </v-flex>
                        <v-flex xs12 md6 v-show="input.pagarmepix.enable">
                            <v-text-field v-model="input.pagarmepix.private" label="Chave secreta (sk_...)" dense
                                hide-details />
                        </v-flex>
                        <v-flex xs12 md6 v-show="input.pagarmepix.enable">
                            <v-text-field v-model="input.pagarmepix.webhookUser" label="Usuário do webhook (opcional)"
                                dense hide-details />
                        </v-flex>
                        <v-flex xs12 md6 v-show="input.pagarmepix.enable">
                            <v-text-field v-model="input.pagarmepix.webhookPassword"
                                label="Senha do webhook (opcional)" dense hide-details />
                        </v-flex>
                        <v-flex xs12 v-show="input.pagarmepix.enable">
                            <v-alert border="left" colored-border color="success" elevation="5" class="ma-0 mt-4">
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <h5 class="success--text">
                                            Dados do cliente enviados para a Pagar.me (obrigatórios para o PIX)
                                        </h5>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field v-model="input.pagarmepix.customerDocument" label="CPF/CNPJ"
                                            dense hide-details />
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field v-model="input.pagarmepix.customerPhone"
                                            label="Telefone (DDD + número)" dense hide-details />
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field v-model="input.pagarmepix.customerEmail"
                                            label="E-mail padrão (sem e-mail do usuário)" dense hide-details />
                                    </v-flex>
                                </v-layout>
                            </v-alert>
                        </v-flex>
                        <v-flex xs12 v-show="input.pagarmepix.enable">
                            <v-alert border="left" colored-border
                                :color="(input.payment.payPartnerTransfer || input.pagarmepix.payPartnerTransfer) ? 'success' : 'error'"
                                elevation="5" class="ma-0 mt-4">
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <h5
                                            :class="(input.payment.payPartnerTransfer || input.pagarmepix.payPartnerTransfer) ? 'success--text' : 'error--text'">
                                            Configuração de parceiro (Split)
                                            {{ (input.payment.payPartnerTransfer ||
                                                input.pagarmepix.payPartnerTransfer)
                                                ? '' : ' - Desabilitada (Necessário configurar porcentagem para parceiro) '
                                            }}
                                        </h5>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <v-text-field v-model="input.pagarmepix.payPartnerTransfer"
                                            :rules="[rules.range(1, 100)]" label="Porcentagem parceiro"
                                            v-mask="['#', '##', '###']" return-masked-value prefix="%" type="number"
                                            dense required />
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <v-text-field v-model="input.pagarmepix.splitIncharge"
                                            label="Recebedor principal (rp_...)" dense hide-details />
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <v-text-field v-model="input.pagarmepix.splitPartner"
                                            label="Recebedor parceiro (rp_...)" dense hide-details />
                                    </v-flex>
                                </v-layout>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-alert>
            </v-flex>
            <v-flex xs12>
                <v-alert border="left" colored-border color="error" elevation="5">
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-row class="px-4">
                                <h4 class="error--text mr-4">Mercado Pago (Cartão)</h4>
                                <v-spacer />
                                <v-switch v-model="input.mercadopago.enable"
                                    :label="input.mercadopago.enable ? 'Habilitado' : 'Desabilitado'" hide-details
                                    class="mt-1 py-0" />
                                <v-btn icon @click="copyPaymentConfig('mercadopago', 'Mercado Pago (Cartão)')"
                                    color="success">
                                    <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                                <v-btn icon @click="pastePaymentConfig('mercadopago', 'Mercado Pago (Cartão)')"
                                    color="error">
                                    <v-icon>mdi-content-paste</v-icon>
                                </v-btn>
                            </v-row>
                        </v-flex>
                        <v-flex xs12 md6 v-show="input.mercadopago.enable">
                            <v-text-field v-model="input.mercadopago.public" label="Chave pública" dense hide-details />
                        </v-flex>
                        <v-flex xs12 md6 v-show="input.mercadopago.enable">
                            <v-text-field v-model="input.mercadopago.private" label="Chave privada" dense
                                hide-details />
                        </v-flex>
                        <v-flex xs12 md6 v-show="input.mercadopago.enable">
                            <v-text-field v-model="input.mercadopago.webhookKey" label="Webhook Key" dense
                                hide-details />
                        </v-flex>
                    </v-layout>
                </v-alert>
            </v-flex>
            <v-flex xs12>
                <v-alert border="left" colored-border color="success" elevation="5">
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-row class="px-4">
                                <h4 class="success--text mr-4">Pagar.me</h4>
                                <v-spacer />
                                <v-switch v-model="input.pagarme.enable"
                                    :label="input.pagarme.enable ? 'Habilitado' : 'Desabilitado'" hide-details
                                    class="mt-1 py-0" />
                                <v-btn icon @click="copyPaymentConfig('pagarme', 'Pagar.me')" color="success">
                                    <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                                <v-btn icon @click="pastePaymentConfig('pagarme', 'Pagar.me')" color="error">
                                    <v-icon>mdi-content-paste</v-icon>
                                </v-btn>
                            </v-row>
                        </v-flex>
                        <v-flex xs12 v-show="input.pagarme.enable">
                            <v-text-field v-model="input.pagarme.private" label="Chave da API" dense hide-details />
                        </v-flex>
                        <v-flex xs12 md6 v-show="input.pagarme.enable">
                            <v-text-field v-model="input.pagarme.machine" label="Código máquina" dense hide-details />
                        </v-flex>
                        <v-flex xs12 md6 v-show="input.pagarme.enable">
                            <v-text-field v-model="input.pagarme.serviceRefererName" label="ServiceRefererName" dense
                                hide-details />
                        </v-flex>
                        <v-flex xs12 md6 v-show="input.pagarme.enable">
                            <v-text-field v-model="input.pagarme.splitIncharge" label="Recebedor principal" dense
                                hide-details />
                        </v-flex>

                        <v-flex xs12 v-show="input.pagarme.enable">
                            <v-alert border="left" colored-border
                                :color="input.payment.payPartnerTransfer ? 'success' : 'error'" elevation="5"
                                class="ma-0">
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <h5 :class="input.payment.payPartnerTransfer ? 'success--text' : 'error--text'">
                                            Configuração de parceiro {{ input.payment.payPartnerTransfer ? '' : ' - Desabilitada (Necessário configurar porcentagem para parceiro)' }}</h5>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field v-model="input.pagarme.splitPartner"
                                            label="Recebedor parceiro (Split)" dense hide-details />
                                    </v-flex>
                                </v-layout>
                            </v-alert>
                        </v-flex>

                    </v-layout>
                </v-alert>
            </v-flex>
            <v-flex xs12>
                <v-btn block color="success" @click="send" :loading="sending"
                    :disabled="sending || !valid">Salvar</v-btn>
            </v-flex>
        </v-layout>
        <ConfirmModal ref="confirm" />
    </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import policies from "@/assets/json/pricePolicies.json";
import rules from "@/helpers/rules";

import ConfirmModal from "@/components/core/ConfirmModal";

export default {
    directives: { mask },

    components: {
        ConfirmModal,
    },

    props: {
        data: {
            type: Object,
            required: true,
        },
        chargerId: {
            type: [String, Number],
            required: true,
        },
    },

    data() {
        return {
            rules,
            valid: true,
            input: null,
            sending: false,
            policies,
        };
    },

    computed: {
        hasAccessToken() {
            return this.input?.mercadopagopix?.access_token;
        },
        isTokenExpired() {
            if (!this.hasAccessToken || !this.input?.mercadopagopix?.expires_in) {
                return false;
            }
            return new Date(Number(this.input.mercadopagopix.expires_in)) < new Date();
        },
        formattedExpiryDate() {
            if (!this.hasAccessToken || !this.input?.mercadopagopix?.expires_in) {
                return '';
            }
            return new Date(Number(this.input.mercadopagopix.expires_in)).toLocaleString('pt-BR');
        },
        requiredIfSplitRefreshToken() {
            return (v) => {
                if (this.hasAccessToken) {
                    return !!v || 'Obrigatório quando há Split Code.';
                }
                return true;
            };
        },
        requiredIfSplitExpiresIn() {
            return (v) => {
                if (this.hasAccessToken) {
                    return !!v || 'Obrigatório quando há Split Code.';
                }
                return true;
            };
        },
    },

    created() {
        if (this.data) {
            this.input = { ...this.data };
            if (!this.data.payment || !this.data.payment.pricePolicy) {
                this.input.payment = {
                    pricePolicy: null,
                    recipient: null,
                    price: null,
                    priceKwh: null,
                    idleTolerance: null,
                    priceIdle: null,
                    priceConnection: null,
                    connectionTolerance: null,
                    payTriggerStop: null,
                    payPartnerTransfer: null,
                };
            }
            if (!this.data.configuration || !this.data.configuration.stopWithStatusNotification) {
                this.input.configuration = {
                    stopWithStatusNotification: false,
                };
            }
        } else {
            this.input = {
                sendUnlockBeforeConnect: false,
                powerMax: null,
                powerControl: false,
                powerFree: null,
                powerFreeTime: null,
                configuration: {
                    stopWithStatusNotification: false,
                },
                payment: {
                    pricePolicy: null,
                    recipient: null,
                    price: null,
                    priceKwh: null,
                    idleTolerance: null,
                    priceIdle: null,
                    priceConnection: null,
                    connectionTolerance: null,
                    payTriggerStop: null,
                    payPartnerTransfer: null,
                },
                stripe: {
                    enable: false,
                    public: null,
                    private: null,
                    partner: null,
                    directChargeMode: false,
                    fee: null,
                    feePerTransaction: null,
                },
                pagarme: {
                    enable: false,
                    private: null,
                    machine: null,
                    serviceRefererName: null,
                    splitIncharge: null,
                    splitPartner: null,
                },
                mercadopago: {
                    enable: false,
                    public: null,
                    private: null,
                    partner: null,
                },
                mercadopagopix: {
                    enable: false,
                    webhookKey: null,
                    private: null,
                    client_id: null,
                    client_secret: null,
                    access_token: null,
                    refresh_token: null,
                    expires_in: null,
                    payPartnerTransfer: null,
                },
                pagarmepix: {
                    enable: false,
                    private: null,
                    webhookUser: null,
                    webhookPassword: null,
                    customerDocument: null,
                    customerPhone: null,
                    customerEmail: null,
                    payPartnerTransfer: null,
                    splitIncharge: null,
                    splitPartner: null,
                },
            };

        }

        if (this.input.payment && this.input.payment.price) {
            this.input.payment.price = parseFloat(this.input.payment.price).toFixed(2);
        }
        if (this.input.payment && this.input.payment.priceKwh) {
            this.input.payment.priceKwh = parseFloat(this.input.payment.priceKwh).toFixed(2);
        }
        if (this.input.payment && this.input.payment.priceIdle) {
            this.input.payment.priceIdle = parseFloat(this.input.payment.priceIdle).toFixed(2);
        }
        if (this.input.stripe == undefined || this.input.stripe.public == undefined) {
            this.input.stripe = {
                enable: false,
                public: null,
                private: null,
                partner: null,
                directChargeMode: false,
                fee: null,
                feePerTransaction: null,
            }
        }
        if (this.input.pagarme == undefined || this.input.pagarme.private == undefined) {
            this.input.pagarme = {
                enable: false,
                private: null,
                machine: null,
                serviceRefererName: null,
                splitIncharge: null,
                splitPartner: null,
            }
        }
        if (this.input.mercadopago == undefined || this.input.mercadopago.public == undefined) {
            this.input.mercadopago = {
                enable: false,
                public: null,
                private: null,
                partner: null,
            }
        }
        if (this.input.mercadopagopix == undefined || this.input.mercadopagopix.private == undefined) {
            this.input.mercadopagopix = {
                enable: false,
                webhookKey: null,
                private: null,
                client_id: null,
                client_secret: null,
                access_token: null,
                refresh_token: null,
                expires_in: null,
                payPartnerTransfer: null,
            }
        }
        if (this.input.pagarmepix == undefined || this.input.pagarmepix.private == undefined) {
            this.input.pagarmepix = {
                enable: false,
                private: null,
                webhookUser: null,
                webhookPassword: null,
                customerDocument: null,
                customerPhone: null,
                customerEmail: null,
                payPartnerTransfer: null,
                splitIncharge: null,
                splitPartner: null,
            }
        }
    },

    methods: {
        updateSplitMercadoPago(data) {
            if (data) {
                if (data.access_token) {
                    this.input.mercadopagopix.access_token = data.access_token;
                }
                if (data.refresh_token) {
                    this.input.mercadopagopix.refresh_token = data.refresh_token;
                }
                if (data.expires_in) {
                    this.input.mercadopagopix.expires_in = data.expires_in;
                }
            }

        },

        deleteSplitCode() {
            this.$refs.confirm.open("Confirma?", "Deseja realmente deletar as configurações de split?").then((confirm) => {
                if (confirm) {
                    this.$http
                        .deleteAlternativeAPI(`api/v2/oauth/link/mercadopago/${this.chargerId}`)
                        .then(() => {
                            this.input.mercadopagopix.access_token = null;
                            this.$eventHub.$emit("msgSuccess", "Removido com sucesso.");
                        })
                        .catch((error) => {
                            this.$eventHub.$emit("msgError", error.message ? error.message : "Erro ao apagar.");
                        });
                }
            });
        },

        refreshSplitCode() {
            this.$refs.confirm.open("Confirma?", "Deseja realmente atualizar as configurações de split? Todas as integrações com essa mesma chave de 'Split Code' também serão atualizadas.").then((confirm) => {
                if (confirm) {
                    this.$http
                        .patchAlternativeAPI(`api/v2/oauth/link/mercadopago/${this.chargerId}/update`)
                        .then((result) => {
                            this.$eventHub.$emit("msgSuccess", "Atualizado com sucesso.");
                            this.updateSplitMercadoPago(result);
                        })
                        .catch((error) => {
                            this.$eventHub.$emit("msgError", error.message ? error.message : "Erro ao apagar.");
                        });
                }
            });
        },

        generateSplitCodeLink() {
            this.$http
                .getAlternativeAPI(`api/v2/oauth/link/mercadopago/${this.chargerId}`)
                .then((result) => {
                    if (result.url) {
                        window.open(result.url, '_blank');
                        this.$eventHub.$emit("msgSuccess", `Link gerado com sucesso!`);
                    } else {
                        this.$eventHub.$emit("msgError", "Erro ao localizar URL.");
                    }
                })
                .catch((error) => {
                    this.$eventHub.$emit("msgError", error.message ? error.message : "Erro ao gerar requisição.");
                });
        },

        send() {
            this.eraseBeforeSave();
            if (this.$refs.form.validate()) {
                this.$refs.confirm.open("Confirma?", "Não modifique as configurações com carregamentos em andamento, ao salva os dados da sessão serão apagados.").then((confirm) => {
                    if (confirm) {
                        this.sending = true;
                        this.$http
                            .put("api/v2/car/configuration", this.input.id, this.input)
                            .then((result) => {
                                this.sending = false;
                                this.$eventHub.$emit("msgSuccess", result.message ? result.message : "Dados salvo com sucesso.");
                                this.$emit("saved");
                            })
                            .catch((error) => {
                                this.sending = false;
                                this.$eventHub.$emit("msgError", error.message ? error.message : "Erro ao salvar dados.");
                            });
                    }
                });
            }
        },

        eraseBeforeSave() {
            if (!this.input.stripe /*|| !this.input.stripe.enable*/) {
                this.input.stripe.public = null;
                this.input.stripe.private = null;
                this.input.stripe.webhookKey = null;
                this.input.stripe.partner = null;
                this.input.stripe.directChargeMode = false;
                this.input.stripe.fee = null;
                this.input.stripe.feePerTransaction = null;
            } else {
                if (!this.input.payment.payPartnerTransfer || this.input.stripe.partner == null || this.input.stripe.partner == '') {
                    this.input.stripe.partner = null;
                    this.input.stripe.directChargeMode = false;
                    this.input.stripe.fee = null;
                    this.input.stripe.feePerTransaction = null;
                }
                if (!this.input.stripe.directChargeMode) {
                    this.input.stripe.fee = null;
                    this.input.stripe.feePerTransaction = null;
                }
            }

            if (!this.input.mercadopagopix /*|| !this.input.mercadopagopix.enable*/) {
                this.input.mercadopagopix.private = null;
                this.input.mercadopagopix.webhookKey = null;
                this.input.mercadopagopix.client_id = null;
                this.input.mercadopagopix.client_secret = null;
                this.input.mercadopagopix.access_token = null;
                this.input.mercadopagopix.refresh_token = null;
                this.input.mercadopagopix.expires_in = null;
                this.input.mercadopagopix.payPartnerTransfer = null;
            } else if (!this.input.mercadopagopix.access_token) {
                this.input.mercadopagopix.refresh_token = null;
                this.input.mercadopagopix.expires_in = null;
            }

        },
        getPaymentClipboardKey(paymentMethod) {
            return `paymentConfig:${paymentMethod}`;
        },

        copyPaymentConfig(paymentMethod, label) {
            if (!this.input || !this.input[paymentMethod]) {
                this.$eventHub.$emit("msgError", `Configuração de ${label} não encontrada.`);
                return;
            }

            localStorage.setItem(
                this.getPaymentClipboardKey(paymentMethod),
                JSON.stringify(this.input[paymentMethod])
            );

            this.$eventHub.$emit("msgSuccess", `Configuração de ${label} copiada com sucesso!`);
        },

        pastePaymentConfig(paymentMethod, label) {
            const clipboardConfig = localStorage.getItem(this.getPaymentClipboardKey(paymentMethod));

            if (!clipboardConfig) {
                this.$eventHub.$emit("msgError", `Nenhuma configuração de ${label} encontrada para colar.`);
                return;
            }

            try {
                const parsedConfig = JSON.parse(clipboardConfig);

                if (typeof parsedConfig !== "object" || parsedConfig === null) {
                    throw new Error("Invalid clipboard config");
                }

                this.input[paymentMethod] = {
                    ...this.input[paymentMethod],
                    ...parsedConfig,
                };

                this.$eventHub.$emit("msgSuccess", `Configuração de ${label} colada com sucesso!`);
            } catch (error) {
                this.$eventHub.$emit("msgError", `Configuração de ${label} inválida para colar.`);
            }
        },
    },
};
</script>